"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRemoveDigestSportResponseDto = instanceOfRemoveDigestSportResponseDto;
exports.RemoveDigestSportResponseDtoFromJSON = RemoveDigestSportResponseDtoFromJSON;
exports.RemoveDigestSportResponseDtoFromJSONTyped = RemoveDigestSportResponseDtoFromJSONTyped;
exports.RemoveDigestSportResponseDtoToJSON = RemoveDigestSportResponseDtoToJSON;
exports.RemoveDigestSportResponseDtoToJSONTyped = RemoveDigestSportResponseDtoToJSONTyped;
/**
 * Check if a given object implements the RemoveDigestSportResponseDto interface.
 */
function instanceOfRemoveDigestSportResponseDto(value) {
    if (!('savedAt' in value) || value['savedAt'] === undefined)
        return false;
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    if (!('removedSportCode' in value) || value['removedSportCode'] === undefined)
        return false;
    return true;
}
function RemoveDigestSportResponseDtoFromJSON(json) {
    return RemoveDigestSportResponseDtoFromJSONTyped(json, false);
}
function RemoveDigestSportResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'savedAt': json['savedAt'],
        'sportCodes': json['sportCodes'],
        'removedSportCode': json['removedSportCode'],
    };
}
function RemoveDigestSportResponseDtoToJSON(json) {
    return RemoveDigestSportResponseDtoToJSONTyped(json, false);
}
function RemoveDigestSportResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'savedAt': value['savedAt'],
        'sportCodes': value['sportCodes'],
        'removedSportCode': value['removedSportCode'],
    };
}
